<template>

  <!--<v-toolbar app dark dense color="primary" style="z-index: 9999;" class="elevation-0">-->
  <!--</v-toolbar>-->

  <v-toolbar app flat prominent extended dark color="primary">

    <!--<v-toolbar-title>-->
      <router-link to="/" class="mr-3">
        <img src="https://esavalanche.wpengine.com/wp-content/uploads/2021/10/EsacLogo_Vector_Black_logoonly-01.png"
             alt="Eastern Sierra Avalanche Center" height="40">
      </router-link>
    <!--</v-toolbar-title>-->

    <!--<v-spacer></v-spacer>-->

    <v-toolbar-items>

      <v-menu offset-y open-on-hover bottom>

        <v-btn flat slot="activator" to="/station/">Stations</v-btn>

        <v-list>

          <v-list-tile
            v-for="(st, index) in stations"
            :key="index"
            :to="`/station/${st.STID}`"
            :disabled="st.STATUS !== 'ACTIVE'"
          >
            <v-list-tile-title>{{st.STID}}: {{st.NAME}}</v-list-tile-title>
          </v-list-tile>

        </v-list>

      </v-menu>

      <v-menu offset-y open-on-hover bottom>

        <v-btn flat slot="activator">Sensor Variable</v-btn>

        <v-list>

          <v-list-tile
            v-for="(favVar, index) in favVars"
            :key="index"
            :to="`/variable/${favVar.name}`"
          >
            <v-list-tile-title>{{favVar.label}}</v-list-tile-title>
          </v-list-tile>

        </v-list>

      </v-menu>

    </v-toolbar-items>

    <date-range-bar slot="extension"></date-range-bar>

  </v-toolbar>

</template>


<script>
  import { orderBy, find } from 'lodash';
  import getStationMetadata from '@/api/getStationMetadata';
  import favStations from '@/models/favorite-stations';
  import favVars from '@/models/favorite-variables';
  import DateRangeBar from './DateRangeBar';

  export default {

    name: 'Navbar',

    components: {
      DateRangeBar,
    },

    data() {
      return {
        favStations,
        favVars,
      };
    },

    async mounted() {
      const result = await getStationMetadata(favStations.map(f => f.stid).join(','));
      const stations = result.STATION.map((st) => {
        const match = find(favStations, { stid: st.STID });
        return {
          ...st,
          priority: match.priority,
        };
      });
      this.$store.commit('SET_STATION_LIST', orderBy(stations, 'priority'));
    },

    computed: {

      stations() {
        return this.$store.state.station.stationList;
      },

    },

  };
</script>



// WEBPACK FOOTER //
// src/components/Navbar.vue